const headers = new Headers({
    'Content-Type': 'application/json'
});

export default headers;
